import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiFileDocumentMultiple } from "@mdi/js";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { Menu } from "./Menu";

export const CallOffContractsMenu: React.FC<Menu> = memo(
  ({ handleClick, leftMenuOpen, user }) => {
    const { t } = useTranslation();

    if (
      !user.equinor ||
      !user.roles_names.includes("Call-Off Contract - View")
    ) {
      return null;
    }

    return (
      <HybridRouteListItemButtonLink
        caption="call off contracts"
        name="callOffContracts"
        onClick={() => handleClick("callOffContracts")}
        title={t("menu.callOffContracts.title")}
        url="/call_off_contract_items/issue_purchase_order"
      >
        <ListItemIcon sx={{ minWidth: "2rem" }}>
          <Icon icon={mdiFileDocumentMultiple} />
        </ListItemIcon>
        {!!leftMenuOpen && (
          <ListItemText
            primary={t("menu.callOffContracts.title")}
            slotProps={{
              primary: { sx: { fontSize: 14 } },
            }}
            sx={{ whiteSpace: "normal" }}
          />
        )}
      </HybridRouteListItemButtonLink>
    );
  },
);
